angular.module('storefront.account')
    .component('vcAccountPayment', {
        templateUrl: 'themes/assets/js/account/account-payment.tpl.liquid',
        require: {
            accountManager: '^vcAccountManager',
        },
        controller: [
            'storefrontApp.mainContext',
            '$translate',
            '$scope',
            'loadingIndicatorService',
            'storefront.customerPaymentProfileApi',
            'confirmDialogService',
            function (
                mainContext,
                $translate,
                $scope,
                loader,
                customerPaymentService,
                confirmDialogService,
            ) {
                const $ctrl = this;

                $ctrl.loader = loader;

                $scope.currentPage = 1;
                $scope.itemsPerPage = 10;

                $scope.$watch('currentPage', function () {
                    getPaymentProfiles($scope.currentPage);
                });

                $ctrl.setForm = function (addCardForm) {
                    $ctrl.addCardForm = addCardForm;
                };

                function formatCreditCardNumber(number) {
                    const onlyDigits = number.replace(/\D+/g, '');
                    return '**** **** **** ' + onlyDigits;
                }

                function formatExpirationDate(stringDate) {
                    const date = new Date(stringDate);
                    let month = date.getMonth() + 1;

                    if (month.toString().length === 1) {
                        month = '0' + month;
                    }

                    const year = date.getFullYear();

                    return month + '/' + year;
                }

                function getPaymentProfiles(page) {
                    $ctrl.loader.isLoading = true;
                    customerPaymentService.search({
                        pageNumber: page,
                        pageSize: $scope.itemsPerPage,
                    })
                        .then(function (response) {
                            $scope.paymentProfiles = response.data.results;
                            $scope.totalItems = response.data.totalCount;
                            $scope.pageCount = response.data.pageCount;
                            $ctrl.loader.isLoading = false;

                            $scope.paymentProfiles.forEach(function (item) {
                                item.creditCard.cardNumber = formatCreditCardNumber(item.creditCard.cardNumber);
                                item.creditCard.expirationDate = formatExpirationDate(item.creditCard.expirationDate);
                            });
                        });
                }

                $ctrl.delete = function ($index) {
                    const showDialog = function (text) {
                        confirmDialogService.confirm(text, function (confirmed) {
                            if (confirmed) {
                                const paymProfile = $scope.paymentProfiles[$index];
                                $scope.paymentProfiles.splice($index, 1);
                                customerPaymentService.delete(paymProfile.customerPaymentProfileId);
                            }
                        });
                    };

                    $translate('customer.payment_methods.delete_confirm').then(showDialog, showDialog);
                };

                $ctrl.addNewCard = function () {
                    $ctrl.newCard = {};
                };

                $ctrl.submitNewCard = function () {
                    $ctrl.addCardForm.$setSubmitted();

                    if (!$ctrl.addCardForm.$valid) {
                        return;
                    }

                    const paymProfile = {
                        creditCard: $ctrl.newCard,
                    };

                    let expYear = String($ctrl.newCard.expirationYear);

                    if (expYear.length === 2) {
                        expYear = '20' + expYear;
                    }

                    let expMonth = String($ctrl.newCard.expirationMonth);

                    if (expMonth.length === 1) {
                        expMonth = '0' + expMonth;
                    }

                    paymProfile.creditCard.expirationDate = expMonth + '/' + expYear;

                    $ctrl.loader.isLoading = true;
                    $ctrl.showSubmitError = false;

                    customerPaymentService.submit(paymProfile)
                        .then(
                            function () {
                                $scope.currentPage = 1;
                                getPaymentProfiles($scope.currentPage);
                                $ctrl.newCard = null;
                            },
                            function () {
                                $ctrl.loader.isLoading = false;
                                $ctrl.showSubmitError = true;
                            },
                        );
                };

                $ctrl.cancelNewCard = function () {
                    $ctrl.newCard = null;
                    $ctrl.showSubmitError = false;
                };
            }],
    });
